import { render, staticRenderFns } from "./content.vue?vue&type=template&id=3fbefc3e&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"
import style0 from "./content.vue?vue&type=style&index=0&id=3fbefc3e&prod&scoped=true&lang=less&"
import style1 from "./content.vue?vue&type=style&index=1&id=3fbefc3e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbefc3e",
  null
  
)

export default component.exports